/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  MenuItem,
  TextField,
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { validate } from "validate.js";
import {
  resetStateApplications,
  updateApplication,
} from "../../app/slices/applicationsSlice";
import { addComment, resetStateComments } from "../../app/slices/commentSlice";
import { showSnackbar } from "../../app/slices/commonSlice";
import {
  fetchReports,
  resetStateReports,
  updateReport,
} from "../../app/slices/reportSlice";
import {
  applicationStatus,
  dateFormat,
  hasAccess,
  isEmpty,
  oracleDateFormat,
  translateStatus,
} from "../../app/utils";
import testAttachmentTypes from "../../assets/static/testReportAttachments.json";
import AttachmentsContainer from "../../components/AttachmentsContainer/AttachmentsContainer";
import CommentsContainer from "../../components/CommentsContainer/CommentsContainer";
import AppTabs from "../../components/appTabs/appTabs";
import ApplicationDetails from "./ApplicationDetails";

const ApplicationLanding = ({ data, open, handleClose }) => {
  const {
    data: dataPut,
    error: errorPut,
    status: statusPut,
  } = useSelector(({ applications }) => applications.put);

  const {
    post: { data: dataPost, status: statusPost, error: errorPost },
  } = useSelector(({ comments }) => comments);

  const {
    list: listTestReports,
    // status: statusTestReports,
    // error: errorTestReports,
  } = useSelector(({ reports }) => reports.get);

  const {
    data: dataPostAttachment,
    // status: statusTestReports,
    // error: errorTestReports,
  } = useSelector(({ attachments }) => attachments.post);

  const { activeSession } = useSelector(({ auth }) => auth);

  const [activeTab, setActiveTab] = useState(0);
  const [tabs, setTabs] = useState([]);
  const [formValues, setFormValues] = useState({
    ...data,
    applicationStatus: data?.status,
  });
  const [errors, setErrors] = useState([]);
  const [attachmentTypes, setAttachmentTypes] = useState([]);
  const dispatch = useDispatch();
  //* use effect
  useEffect(() => {
    let _tabs = [];

    _tabs.push(
      {
        title: "Details",
      },
      {
        title: "Attachments",
      },
      {
        title: "Actions & Comments",
      }
    );
    setTabs([..._tabs]);
  }, []);

  useEffect(() => {
    let _attachmentTypes = [];
    if (hasAccess({ type: "name", resource: "EDIT_APPLICATION" })) {
      //evaluator attachment types
      _attachmentTypes.push(
        testAttachmentTypes.find((x) => x.name.includes("Onsite"))
      );
      _attachmentTypes.push({
        name: "Recommendation Letter",
        extension: "application/pdf",
      });
    } else {
      //applicant attachment types
      _attachmentTypes.push(
        testAttachmentTypes.find((x) => x.name.includes("Progress"))
      );
      _attachmentTypes.push(
        testAttachmentTypes.find((x) => x.name.includes("Final"))
      );
    }
    setAttachmentTypes(_attachmentTypes);
  }, []);

  useEffect(() => {
    if (dataPost || dataPut) {
      dispatch(
        showSnackbar({
          open: true,
          message: "Changes saved successfully",
          type: "success",
        })
      );
      dispatch(resetStateComments(["post"]));
      dispatch(resetStateReports(["post"]));
      dispatch(resetStateApplications(["put"]));
      handleClose(true);
    }
  }, [dataPost, dataPut]);

  useEffect(() => {
    if (errorPost || errorPut) {
      dispatch(
        showSnackbar({
          open: true,
          message:
            errorPost?.message || errorPut?.message || "An error occurred",
          type: "error",
        })
      );
    }
  }, [errorPost]);

  useEffect(() => {
    if (
      data?.status === "T" &&
      !hasAccess({ type: "name", resource: "EDIT_APPLICATION" }) &&
      activeTab === 1
    ) {
      //fetch test reports
      dispatch(
        fetchReports({
          APPLICATION_ID: data?.applicationId,
        })
      );
    }
  }, [activeTab]);

  useEffect(() => {
    if (dataPostAttachment) {
      if (
        !isEmpty(formValues?.uploadedReport) &&
        !hasAccess({ type: "name", resource: "EDIT_APPLICATION" })
      ) {
        let reportId = formValues?.uploadedReport;
        //attachment has uploaded, update report application id
        dispatch(
          updateReport({
            id: reportId,
            payload: {
              ATTACHMENT_ID: dataPostAttachment,
              DATE_UPLOADED: moment().format(oracleDateFormat),
            },
          })
        );
        setTimeout(() => {
          setFormValues({ ...formValues, updateReport: undefined });
        }, 1000);
      }
    }
  }, [dataPostAttachment]);

  //methods
  const handleSubmit = async () => {
    let _validators = {};
    if (
      formValues?.applicationStatus === "R" ||
      formValues?.applicationStatus === "N" ||
      formValues?.applicationStatus === "P"
    ) {
      _validators.comment = {
        presence: { allowEmpty: false },
      };
    }
    let _errors = validate(formValues, _validators);

    if (_errors) {
      setErrors(_errors);
    } else {
      setErrors([]);

      if (formValues?.comment) {
        dispatch(
          addComment({
            DATA: formValues?.comment,
            EMAIL: activeSession.EMAIL,
            RECORD_ID: data?.applicationId,
            ACTION: applicationStatus?.find(
              (i) => i?.value === formValues?.status
            )?.label,
          })
        );
      }

      if (formValues?.applicationStatus !== data?.status) {
        dispatch(
          updateApplication({
            id: formValues?.applicationId,
            payload: {
              STATUS: formValues?.applicationStatus,
            },
          })
        );
      } else {
        dispatch(
          showSnackbar({
            open: true,
            message: "No changes were made.",
            type: "warning",
          })
        );
      }
    }
  };

  //* builders

  const BuildTabViews = () => {
    switch (activeTab) {
      case 0:
        return <ApplicationDetails data={data} />;
      case 1:
        return (
          <div className="app-padding">
            {data?.status === "T" &&
              !hasAccess({ type: "name", resource: "EDIT_APPLICATION" }) &&
              listTestReports && (
                <div className="mb-10 mt-20">
                  <h3>Upload Test Reports</h3>
                  <div className="mt-10">
                    Choose the report you are uploading
                  </div>
                  <Grid container>
                    <Grid
                      item
                      md={4}
                      sm={8}
                      xs={12}
                      className="padded-grid-item"
                    >
                      <TextField
                        required
                        fullWidth
                        margin="dense"
                        autoComplete="new-password"
                        variant="outlined"
                        name={"uploadedReport"}
                        select
                        id={"input-report"}
                        label={"Report"}
                        onChange={(e) => {
                          setFormValues({
                            ...formValues,
                            uploadedReport: e?.target.value,
                          });
                        }}
                        value={formValues?.uploadedReport || null}
                      >
                        {listTestReports
                          .filter((x) => x?.ATTACHMENT_ID === null)
                          .map((option) => (
                            <MenuItem
                              key={`report-${option?.REPORT_NO}`}
                              value={option?.REPORT_NO}
                            >
                              {`${option?.REPORT_NAME}, Due ${moment(
                                option?.DUE_DATE
                              ).format(dateFormat)}`}
                            </MenuItem>
                          ))}
                      </TextField>
                    </Grid>
                  </Grid>
                </div>
              )}
            <AttachmentsContainer
              recordId={data?.applicationId}
              readOnly={
                (data?.status !== "T" && data?.status !== "P") ||
                !hasAccess({ type: "name", resource: "EDIT_APPLICATION" })
                  ? isEmpty(formValues?.uploadedReport)
                    ? true
                    : false
                  : false
              }
              sourceTable="applications"
              attachmentTypes={attachmentTypes}
            />
          </div>
        );
      case 2:
        return (
          <CommentsContainer
            recordId={data?.applicationId}
            formValues={formValues}
            errors={errors}
            setFormValues={setFormValues}
            setErrors={setErrors}
          />
        );
      default:
        break;
    }
  };

  return (
    <>
      <Dialog open={open} fullWidth maxWidth={"xl"} className="dialog-height">
        <DialogTitle id="responsive-dialog-title">
          <span>
            <b>STATUS : {translateStatus(data?.status)}</b>
          </span>
        </DialogTitle>

        <DialogContent>
          <DialogContentText>
            <AppTabs
              tabs={tabs}
              activeTab={activeTab}
              handleTabChange={(index) => {
                setActiveTab(index);
              }}
            />
            {tabs?.length && BuildTabViews()}
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Grid
            item
            md={12}
            className="flex-row justify-content-space-between"
            style={{ width: "100%", margin: "0px 10px" }}
          >
            <Grid item lg={6} style={{ width: "49%" }}>
              {hasAccess({ type: "name", resource: "EDIT_APPLICATION" }) && (
                <TextField
                  variant="outlined"
                  fullWidth
                  label="Comment"
                  multiline
                  value={formValues?.comment}
                  error={errors["comment"] ? true : false}
                  helperText={errors["comment"] ? errors.comment[0] : null}
                  onChange={(event) => {
                    setFormValues({
                      ...formValues,
                      comment: event.target.value,
                    });
                  }}
                />
              )}
            </Grid>

            <Grid item lg={6} className="padded-grid-item">
              {hasAccess({ type: "name", resource: "EDIT_APPLICATION" }) &&
                (formValues?.status || formValues?.comment) && (
                  <Button
                    size="small"
                    id="btn-submit"
                    margin="dense"
                    disabled={
                      statusPost === "loading" || statusPut === "loading"
                    }
                    color="primary"
                    variant="contained"
                    onClick={handleSubmit}
                  >
                    {(statusPost === "loading" || statusPut === "loading") && (
                      <CircularProgress
                        size={18}
                        style={{
                          marginRight: "5px",
                        }}
                      />
                    )}
                    Submit
                  </Button>
                )}

              <Button
                size="small"
                id="btn-close"
                disabled={statusPost === "loading" || statusPut === "loading"}
                margin="dense"
                color="secondary"
                variant="contained"
                onClick={handleClose}
                style={{ marginLeft: "10px", marginRight: "20px" }}
              >
                Close
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ApplicationLanding;
